import React, { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import { Dialog, DialogTitle, DialogContent, Button, Table, TableBody, TableCell, TableRow, LinearProgress, Box, IconButton } from '@mui/material';
import { sendApiRequest } from '../lib/api/public';
import CloseIcon from '@mui/icons-material/Close';
import CustomQuestionForm from '../components/CustomQuestionForm';

const CustomQuestionsManager = ({ onClose }) => {
  const router = useRouter();
  const [isLoading, setLoading] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [selectedQuestion, setSelectedQuestion] = useState(null);
  const [customQuestions, setCustomQuestions] = useState([]);

  const getCustomQuestions = () => {
    if (router.isReady) {
      setLoading(true);

      sendApiRequest({
        path: `/custom-questions`,
        method: 'GET',
      }).then((response: any) => {
        setLoading(false);

        if (!response.error) {
          if (response.length === 0) {
            setShowForm(true);
          }

          setCustomQuestions(response);
        }
      })
    }
  }

  const renderQuestionForm = () => {
    if (!showForm) {
      return null;
    }

    return (
      <CustomQuestionForm
        open={true}
        customQuestion={selectedQuestion}
        onClose={() => { setSelectedQuestion(null); setShowForm(false); }}
        onSuccess={() => { setSelectedQuestion(null); setShowForm(false); getCustomQuestions(); onClose(); }}
      />
    )
  }

  useEffect(() => {
    getCustomQuestions();
  }, [])

  return (

    <Dialog open={true} onClose={onClose} fullScreen sx={{ width: '40%', left: 'inherit' }}>
      <DialogTitle>
        <Box display="flex" alignItems="center">
          <Box flexGrow={1}>Manage custom application questions</Box>
          <Box display="flex" alignItems="center">
            <Box>
              <IconButton onClick={onClose}>
                <CloseIcon />
              </IconButton>

              <Button
                onClick={() => { setSelectedQuestion(null); setShowForm(true); }}
                variant="contained"
              >
                + Add new
              </Button>
            </Box>
          </Box>
        </Box>
      </DialogTitle>

      <DialogContent>
        {isLoading && <LinearProgress />}

        {renderQuestionForm()}

        <div>
          <div
            style={{
              float: 'right',
            }}
          >

            {'  '}
          </div>

          <div style={{ clear: 'both' }} />

          <br />
          <br />

          <Table sx={{ minWidth: 650 }}>
            <TableBody>
              {customQuestions.map((question, index) => (
                <TableRow
                  key={question._id}
                  onClick={() => { setSelectedQuestion(question); setShowForm(true); }}
                >
                  <TableCell style={{ width: '5px' }}>{index + 1}</TableCell>
                  <TableCell>{question.name}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default CustomQuestionsManager;
